import React from 'react';
import './ResultField.css';


function ResultField({item}) {

  const [isOpen, setIsOpen] = React.useState(false)

  function handleClike() {
    setIsOpen(!isOpen)
  }

  return (
    <tr className={`tests__main-wrapper${isOpen === true && 'tests__main-wrapper_active'}`}>

      <td className={`tests__container tests__container-btn ${isOpen === true && 'tests__container_active'}`}>
        <p className={`tests__td-text ${isOpen === true && 'tests__td-text-btn_active'}`}>{item.argument}</p>
            
        <button className='tests__btn' onClick={handleClike}>
          {isOpen ? 'Свернуть ↑' : 'Развернуть ↓'}
        </button>
      </td>

      <td className='tests__container'>
        
        <p className={`tests__td-text ${isOpen === true && 'tests__td-text_active'}`}>{item.correct_output}</p>
      </td>

      <td className='tests__container'>
        <p className={`tests__td-text tests__td-word-wrap ${isOpen === true && 'tests__td-text_active'}`}>{item.user_output}</p>
      </td>

      <td className='tests__container tests__td-text-time-limit'>
        
        <p className={`tests__td-text ${isOpen === true && 'tests__td-text_active'}`}>{item.time_limit}</p>
      </td>

      <td className='tests__container tests__td-text-time-limit'>
        
        <p className={`tests__td-text ${isOpen === true && 'tests__td-text_active'}`}>{item.user_time}</p>
      </td>

      <td className='tests__container tests__container_general'>
        
        <p className={`tests__td-error-text ${isOpen === true && 'tests__td-error-text_active'}`}>{item.error}</p>
      </td>

      <td className={`tests__container_result ${item.result === false && 'tests__container_bad-result'}`}>
        {item.result === true ? 'Пройден' : 'Не пройден'}
      </td>

    </tr>
  );
}

export default ResultField;